<div class="row text-center pt-5">
  <div class="col-12 mt-md-0 pt-md-0 pt-5 mt-5"><h3 class="font-weight-normal">{{'errors.401.header' | translate}}</h3>
  </div>
  <div [innerHTML]="'errors.401.body' | translate: {'link': loginLink}" class="col-12 font-size-lg"></div>
</div>
